// extracted by mini-css-extract-plugin
export var grid = "_2f-0";
export var span1 = "_2f-2";
export var span10 = "_2f-b";
export var span10L = "_2f-z";
export var span10M = "_2f-n";
export var span10Xl = "_2f-1b";
export var span11 = "_2f-c";
export var span11L = "_2f-10";
export var span11M = "_2f-o";
export var span11Xl = "_2f-1c";
export var span12 = "_2f-d";
export var span12L = "_2f-11";
export var span12M = "_2f-p";
export var span12Xl = "_2f-1d";
export var span1L = "_2f-q";
export var span1M = "_2f-e";
export var span1Xl = "_2f-12";
export var span2 = "_2f-3";
export var span2L = "_2f-r";
export var span2M = "_2f-f";
export var span2Xl = "_2f-13";
export var span3 = "_2f-4";
export var span3L = "_2f-s";
export var span3M = "_2f-g";
export var span3Xl = "_2f-14";
export var span4 = "_2f-5";
export var span4L = "_2f-t";
export var span4M = "_2f-h";
export var span4Xl = "_2f-15";
export var span5 = "_2f-6";
export var span5L = "_2f-u";
export var span5M = "_2f-i";
export var span5Xl = "_2f-16";
export var span6 = "_2f-7";
export var span6L = "_2f-v";
export var span6M = "_2f-j";
export var span6Xl = "_2f-17";
export var span7 = "_2f-8";
export var span7L = "_2f-w";
export var span7M = "_2f-k";
export var span7Xl = "_2f-18";
export var span8 = "_2f-9";
export var span8L = "_2f-x";
export var span8M = "_2f-l";
export var span8Xl = "_2f-19";
export var span9 = "_2f-a";
export var span9L = "_2f-y";
export var span9M = "_2f-m";
export var span9Xl = "_2f-1a";
export var stretch = "_2f-1";